import { Fragment, useState } from 'react';
import { Popover, Transition } from '@headlessui/react';
import { Icon } from '@iconify/react';
import { storageGet } from 'src/utils';
import * as SVG from 'src/assets/icons';
import Image from 'src/components/reusable/Image';
import clsxm from 'src/utils/clsxm';
import { UnstyledLink } from 'src/components/reusable/Links';
import { PATH_DASHBOARD } from 'src/routes/path';
import LogoutModal from './LogoutModal';

const items = [
  {
    name: 'My account',
    href: PATH_DASHBOARD.general.my_account
  },
  {
    name: 'Transaction history',
    href: PATH_DASHBOARD.general.transaction_history
  },
  {
    name: 'Log out',
    href: '#'
  }
];

const UserDropdown = () => {
  const [isHovered, setIsHovered] = useState('');
  const [openLogout, setOpenLogout] = useState(false);
  const userData = storageGet('token');

  const handleClose = () => {
    setOpenLogout(false);
  };

  return (
    <div className="flex justify-end w-full">
      <Popover className="relative">
        {({ open }) => (
          <>
            <Popover.Button
              className={clsxm(
                open ? '' : 'text-opacity-90',
                'group inline-flex gap-x-3 items-center rounded-md py-2 text-base font-medium hover:text-opacity-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 text-black'
              )}
            >
              <Image className="" src={SVG.UserGiftCard} />
              <span className="hidden lg:flex text-ellipsis font-semibold">
                {userData?.email || 'Olusegun'}
              </span>
              <Icon
                icon="akar-icons:chevron-down"
                className={clsxm(
                  open ? '' : 'text-opacity-70',
                  'ml-2 h-5 w-5 transition duration-150 ease-in-out group-hover:text-opacity-80 hidden md:flex'
                )}
                aria-hidden="true"
              />
            </Popover.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel className="absolute -left-full md:left-1/2 z-10 mt-3 min-w-[16rem] -translate-x-1/2 transform px-4 sm:px-0 lg:max-w-3xl">
                <div className="overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5">
                  <div className="relative grid grid-cols-1 gap-8 py-7 bg-white">
                    {items.map((item, index) => (
                      <UnstyledLink
                        key={item.name}
                        href={item.href}
                        onClick={() => isHovered === 'Log out' && setOpenLogout(true)}
                        className="px-7 py-3 -m-3 rounded-lg transition duration-150 ease-in-out hover:bg-gray-50 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                        onMouseEnter={() => setIsHovered(item.name)}
                        onMouseLeave={() => setIsHovered('')}
                      >
                        <div className="flex justify-between items-center">
                          <p className="text-base font-medium text-gray-900">
                            {item.name}
                          </p>
                          {isHovered === item.name && (
                            <Icon
                              className="text-base"
                              icon="carbon:chevron-right"
                            />
                          )}
                        </div>
                      </UnstyledLink>
                    ))}
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
      <LogoutModal
        isOpen={openLogout}
        closeModal={handleClose}
        userData={userData}
      />
    </div>
  );
};

export default UserDropdown;
